import { render, staticRenderFns } from "./AlocacaoBudget.vue?vue&type=template&id=f165f5b8&"
import script from "./AlocacaoBudget.vue?vue&type=script&lang=js&"
export * from "./AlocacaoBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports